import InfoIcon from '@mui/icons-material/Info';
import { TextField, IconButton, InputAdornment, Grid, Button, Typography, Tooltip} from "@mui/material";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { useFormContext, Controller } from "react-hook-form";
import Iconify from "../../../../reusable-components/iconify";
import { formStyle, buttonStyle } from '../TransitionStyles';

FormEmailDomainField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
}

export default function FormEmailDomainField({ fieldName, fieldAttributes, focusedField, setFocusedField }) {
  const { control, getValues, setValue, trigger } = useFormContext();
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);
  const domainRegex = /^@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const setEmailDomain = (value, emailDomain) => `${value?.replace(/[@].*/, "")}${emailDomain}`;

  const setEmailValues = (value) => { 
    const newValue = !value ? '' : value;

    Object.keys(getValues())
    .forEach(x => {
      const staffMember = getValues(x);
      getValues(`${x}.staffMembers`)?.forEach((y, index) => {
        if (!staffMember.isDiffDept && !staffMember.isVacant && !staffMember.contracted) {
          setValue(`${x}.staffMembers[${index}].email`, setEmailDomain(y.email ?? '', newValue))
        }
      })
    })
  }
  
  return <Grid>
    <Grid>
      <Typography variant='subtitle1' color="text.secondary">
        {fieldAttributes.questionTitle}
          <Tooltip
            placement="top"
            arrow
            title="Edit the email domain and click 'Apply To All' to modify or clear all email fields"
            sx={{ fontSize: "1rem" }}
          >
            <InfoIcon color="secondary" fontSize="small" />
          </Tooltip>
      </Typography>
    </Grid>
    <Grid container wrap="nowrap" sx={{mb: 2}}>
      <Controller
        name={fieldName}
        control={control}
        rules={{
          required: fieldAttributes?.validation?.required ?? undefined,
          minLength: fieldAttributes?.validation?.minLength ?? undefined,
          pattern: {
            value: domainRegex,
            message: 'Enter a valid email domain (e.g., example.com)',
          },
        }}
        render={({ field, fieldState }) => (<>
          <TextField
            inputRef={field.ref}
            key={field.id}
            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }}
            onFocus={() => setFocusedField(fieldName)}
            inputProps={{
              onBlur: () => setFocusedField(null),
            }}
            autoComplete="off"
            fullWidth
            size="small"
            type="text"
            disabled={!fieldAttributes.isEditable || isCanceled}
            value={field.value ?? '@'}
            error={!!fieldState.error}
            onChange={(e) => {
              const cleaned = e.target.value.replace(/@/g, '');
              if (cleaned === '') {
                field.onChange(null);
              } else {
                field.onChange(`@${cleaned}`);
              }
            }}
            helperText={fieldState.error?.message}
            sx={{ ...formStyle, width: '300px',  }}
            InputProps={{
              endAdornment: (
                field.value && focusedField === fieldName ? <InputAdornment position="end">
                  <IconButton
                    size="small"
                    onMouseDown={(e) => {
                      e.preventDefault();
                      field.onChange(null);
                    }}
                    edge="end"
                    tabIndex={-1}
                  >
                    <Iconify icon="eva:close-outline" />
                  </IconButton>
                </InputAdornment> : null
              ),
            }}
          />
          <Button
            onClick={async () => { if(await trigger('emailDomain')) setEmailValues(field.value);  }}
            color="primary"
            variant="contained"
            sx={{ height: '33px', width: '85px', ml: 1, ...buttonStyle }}
            disabled={!fieldAttributes.isEditable || isCanceled}
          >
            Apply to all
          </Button>
        </>)}
      />
    </Grid>
  </Grid>
}